<template>
  <b-row>
    <b-col>
      <b-card title="Customs duty report">
        <b-form @submit.prevent="sendExcel">
          <b-row>
            <b-col
              lg="3"
              md="4"
            >
              <b-form-group
                label="Date range"
                label-for="date-range"
              >
                <div class="d-flex align-items-center">
                  <flat-pickr
                    id="date-range"
                    v-model="filters.dateRange"
                    class="form-control"
                    :config="datepickerConfig"
                  />
                  <feather-icon
                    v-b-tooltip.hover.right="'Date range is applied to the customs duty time in each declaration\'s customs country local time. The excel contains both UTC and local times.'"
                    icon="AlertCircleIcon"
                    class="ml-1"
                    size="1.5x"
                  />
                </div>
              </b-form-group>
            </b-col>
            <b-col>
              <b-button
                type="submit"
                variant="primary"
                style="margin-top: 20px"
                :disabled="!canSubmit || loading"
              >
                <b-spinner
                  v-if="loading"
                  small
                  class="mr-50"
                />
                Send Excel to email
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BForm,
  BFormGroup,
  BSpinner,
  VBTooltip,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import moment from 'moment'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { searchQuery } from '@core/utils/filter'
import handleError from '@/views/components/errorHandler'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BForm,
    BFormGroup,
    BSpinner,
    flatPickr,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      loading: false,
      filters: {
        dateRange: `${moment().startOf('month').format('YYYY-MM-DD')} to ${moment().format('YYYY-MM-DD')}`,
      },
      datepickerConfig: {
        mode: 'range',
        maxDate: moment().format('YYYY-MM-DD'),
      },
    }
  },
  computed: {
    canSubmit() {
      return !!this.filters.dateRange
    },
  },
  methods: {
    sendExcel() {
      const [dateFrom, dateTo] = this.filters.dateRange.includes(' to ')
        ? this.filters.dateRange.split(' to ')
        : [this.filters.dateRange, this.filters.dateRange]

      this.loading = true
      this.$http.get(searchQuery('/v1/report/customs-duty/excel', { dateFrom, dateTo }))
        .then(response => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: response.data.message,
              icon: 'MailIcon',
              variant: 'success',
            },
          })
        })
        .catch(error => {
          handleError(error, this.$toast)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
